import { GRID_WIDTH } from '../../../../util/designGrid';

export const PLANE_VISUAL_DEPTH = 1;

export const PLANE_VISUAL_BASE_LINE_WIDTH = 2;

export const PLANE_VISUAL_TOOTH_SIZE = 10;
export const PLANE_VISUAL_TEETH_PER_GRID_LENGTH = 50;

// Not as long as our usual "infinite line" visuals as the base visual teeth are expensive to render "infinitely".
export const INFINITE_PLANE_VISUAL_LENGTH = GRID_WIDTH;
